import { Button } from '../../ui/catalyst/button';
import {
  Dialog,
  DialogActions,
  DialogBody,
  DialogDescription,
  DialogTitle,
} from '../../ui/catalyst/dialog';

interface DeleteEncounterDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onDelete: () => void;
}

export const DeleteEncounterDialog = ({
  isOpen,
  onClose,
  onDelete,
}: DeleteEncounterDialogProps) => {
  return (
    <Dialog open={isOpen} onClose={onClose}>
      <DialogTitle>Delete Encounter</DialogTitle>
      <DialogDescription>
        Are you sure you want to delete this encounter? This action cannot be
        undone.
      </DialogDescription>
      <DialogBody>
        <DialogActions>
          <Button onClick={onClose}>Cancel</Button>
          <Button color="red" onClick={onDelete}>
            Delete
          </Button>
        </DialogActions>
      </DialogBody>
    </Dialog>
  );
};
